import {
  TableCell,
  TableRow,
  TableBody,
  Table,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import useFetch from "hooks/useFetch";
import { useEffect, useState } from "react";
import { MAIN_URL } from "services/api";

import Chargement from "components/Chargement";
import { Db } from "helper/db";
import i18n from "helper/i18n";

const Details = ({ currentId, close }) => {
  const [data, load, cancel] = useFetch("get_details/" + currentId);
  const [details, setDetails] = useState({});
  const [urlPhoto, setUrlPhoto] = useState();

  useEffect(() => {
    load().then((rep) => {
      if (rep) {
        let _tmp = { ...rep };
        if (_tmp[Db.benef_photo] !== null) {
          setUrlPhoto(`${MAIN_URL}/get_image/${_tmp[Db.benef_photo]}`);
        }
        delete _tmp[Db.benef_photo];
        delete _tmp[Db.benef_id];
        setDetails(_tmp);
      }
    });

    return () => {
      cancel.cancel();
    };
  }, []);

  return (
    <>
      <DialogTitle>
        Details béneficiaire
        <IconButton
          aria-label="close"
          onClick={close}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Chargement loading={data.loading} />

        <div className="image_container">
          <img src={urlPhoto} alt="" />
        </div>

        <Table>
          <TableBody>
            {details &&
              Object.keys(details).map((item, keyRow) => (
                <TableRow
                  key={keyRow}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <b>{i18n[item]}</b>
                  </TableCell>
                  <TableCell align="right">
                    {Array.isArray(details[item])
                      ? details[item].join(", ")
                      : details[item]}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </DialogContent>
    </>
  );
};

export default Details;
